import ExportJsonExcel from 'js-export-excel';

class FornMNMPReportExcel {
    exportExcel(data) {
        let option = {};  // La opción representa el archivo de Excel
        let fornMNMPReportData = this.fornMNMPReport(data);
        option.fileName = 'Planilla MNP';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: fornMNMPReportData.data,  // Fuente de datos en archivo Excel
                sheetName: 'Planilla MNP',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel

    }

    fornMNMPReport(dataReport) {
        let dataTable = [];
        
        let casillasTitulo = this.generarTituloCasillas();
        dataTable.push(casillasTitulo);  

        for (let i = 0; i < dataReport.length; i++) {
            let casillaData = this.generarCasillasRecibo(dataReport[i]);
            dataTable.push(casillaData);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTituloCasillas() {
        let casillas = {
            '1': "Fecha Envio",
            '2': "Codigo Habilitación",
            '3': "Nombre Prestador Remitente",
            '4': "Admision No.",
            '5': "Tipo Identificación del Afiliado",
            '6': "Número de Identificacion del Afiliado",
            '7': "Nombre Paciente",
            '8': "Celular Paciente",
            '9': "Fecha de Atención",
            '10': "CIE10",
            '11': "Nombre Medico",
            '12': "Codigo Especialidad",
            '13': "Especialidad Remitente",
            '14': "CUPS Servicio",
            '15': "Nombre Servicio",
            '16': "Tipo de orden", 
            '17': "Cant.",
            '18': "CUPS orden",
            '19': "Orden Médica",
            '20': "Justificacion Clinica",
            '21': "Edad Gestacional",
            '22': "Anestecia",
            '23': "Sedacion",
            '24': "Contraste",
            '25': "Comparativo",
            '26': "Bilateral",
        }
        return casillas;
    }

    generarCasillasRecibo(dataAdm) {
        let casillas = {
            '1': dataAdm.fecha_envio != null && dataAdm.fecha_envio != undefined ? dataAdm.fecha_envio : "",
            '2': dataAdm.codigo_habilitacion != null && dataAdm.codigo_habilitacion != undefined ? dataAdm.codigo_habilitacion : "",
            '3': dataAdm.nombre_prestador != null && dataAdm.nombre_prestador != undefined ? dataAdm.nombre_prestador : "",
            '4': dataAdm.id_admision != null && dataAdm.id_admision != undefined ? dataAdm.id_admision : "",
            '5': dataAdm.tip_documento != null && dataAdm.tip_documento != undefined ? dataAdm.tip_documento : "",
            '6': dataAdm.num_documento != null && dataAdm.num_documento != undefined ? dataAdm.num_documento : "",
            '7': dataAdm.nombre_paciente != null && dataAdm.nombre_paciente != undefined ? dataAdm.nombre_paciente : "",
            '8': dataAdm.celular_paciente != null && dataAdm.celular_paciente != undefined ? dataAdm.celular_paciente : "",
            '9': dataAdm.fecha_atencion != null && dataAdm.fecha_atencion != undefined ? dataAdm.fecha_atencion : "",
            '10':dataAdm.cie10 != null && dataAdm.cie10 != undefined ? dataAdm.cie10 : "", 
            '11': dataAdm.nombre_medico != null && dataAdm.nombre_medico != undefined ? dataAdm.nombre_medico : "",
            '12': dataAdm.codigo_especialidad != null && dataAdm.codigo_especialidad != undefined ? dataAdm.codigo_especialidad : "",
            '13': dataAdm.especialidad_remitente != null && dataAdm.especialidad_remitente != undefined ? dataAdm.especialidad_remitente : "",
            '14': dataAdm.cups != null && dataAdm.cups != undefined ? dataAdm.cups : "",
            '15': dataAdm.nombre_servicio != null && dataAdm.nombre_servicio != undefined ? dataAdm.nombre_servicio : "",
            '16': dataAdm.typeOrder != null && dataAdm.typeOrder != undefined ? dataAdm.typeOrder : "",
            '17': dataAdm.cantOrder != null && dataAdm.cantOrder != undefined ? dataAdm.cantOrder : "",
            '18': dataAdm.cupsOrders != null && dataAdm.cupsOrders != undefined ? dataAdm.cupsOrders : "",
            '19': dataAdm.ordenesAdmission != null && dataAdm.ordenesAdmission != undefined ? dataAdm.ordenesAdmission : "",
            '20': dataAdm.justificacion_clinica != null && dataAdm.justificacion_clinica != undefined ? dataAdm.justificacion_clinica : "",
            '21': dataAdm.edad_gestacional != null && dataAdm.edad_gestacional != undefined ? dataAdm.edad_gestacional : "",
            '22': dataAdm.anestecia != null && dataAdm.anestecia != undefined ? dataAdm.anestecia : "",
            '23': dataAdm.sedacion != null && dataAdm.sedacion != undefined ? dataAdm.sedacion : "",
            '24': dataAdm.contraste != null && dataAdm.contraste != undefined ? dataAdm.contraste : "", 
            '25': dataAdm.comparativo != null && dataAdm.comparativo != undefined ? dataAdm.comparativo : "", 
            '26': dataAdm.bilateral != null && dataAdm.bilateral != undefined ? dataAdm.bilateral : "", 
        }
        return casillas;
    }

}

export default new FornMNMPReportExcel();